import { apiFetch } from './client';

export type OrderStatus = 'cart' | 'submitted' | 'paid' | 'shipped' | 'cancelled' | 'refunded';

export interface ProductRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  sku: string | null;
  name: string;
  description: string | null;
  price_cents: number;
  currency: string;
  stock_qty: number | null;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface OrderRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  caller_id: string | null;
  number: string;
  status: OrderStatus;
  subtotal_cents: number;
  tax_cents: number;
  shipping_cents: number;
  total_cents: number;
  placed_at: string | null;
  paid_at: string | null;
  shipped_at: string | null;
  created_at: string;
  item_count: number;
}

export interface OrderItemRow {
  id: string;
  order_id: string;
  product_id: string | null;
  name: string;
  unit_price_cents: number;
  quantity: number;
  amount_cents: number;
  created_at: string;
}

export interface CreateProductBody {
  sku?: string | null;
  name: string;
  description?: string | null;
  price_cents: number;
  currency?: string;
  stock_qty?: number | null;
  customer_id?: string;
}

export interface PatchProductBody {
  sku?: string | null;
  name?: string;
  description?: string | null;
  price_cents?: number;
  currency?: string;
  stock_qty?: number | null;
  active?: boolean;
}

export const shop = {
  listProducts: (p: { search?: string; limit?: number; active?: boolean; customer_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.search) q.set('search', p.search);
    if (p.limit) q.set('limit', String(p.limit));
    if (p.active) q.set('active', 'true');
    if (p.customer_id) q.set('customer_id', p.customer_id);
    return apiFetch<{ rows: ProductRow[] }>(`/api/products?${q}`);
  },
  getProduct: (id: string) => apiFetch<ProductRow>(`/api/products/${id}`),
  createProduct: (body: CreateProductBody) =>
    apiFetch<ProductRow>('/api/products', {
      method: 'POST', body: JSON.stringify(body),
    }),
  updateProduct: (id: string, body: PatchProductBody) =>
    apiFetch<ProductRow>(`/api/products/${id}`, {
      method: 'PATCH', body: JSON.stringify(body),
    }),
  removeProduct: (id: string) =>
    apiFetch<void>(`/api/products/${id}`, { method: 'DELETE' }),

  listOrders: (p: { status?: OrderStatus; caller_id?: string; limit?: number; customer_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.status) q.set('status', p.status);
    if (p.caller_id) q.set('caller_id', p.caller_id);
    if (p.limit) q.set('limit', String(p.limit));
    if (p.customer_id) q.set('customer_id', p.customer_id);
    return apiFetch<{ rows: OrderRow[] }>(`/api/orders?${q}`);
  },
  getOrder: (id: string) =>
    apiFetch<{ order: OrderRow; items: OrderItemRow[] }>(`/api/orders/${id}`),
};
